module.exports = __webpack_public_path__ + "static/media/winner-cup.4f6eaeff.svg";